export default __webpack_public_path__ + "53760dd32dabdcc410dd1f8d6056d7fa.png";